import moment from 'moment-timezone';

export const dateFilterParams = {
	comparator: (filterLocalDateAtMidnight, cellValue) => {
		if (!cellValue) return -1;

		// Convert cellValue to Singapore time
		const cellMoment = moment.utc(cellValue).tz('Asia/Singapore');

		// Get year, month, date from filterLocalDateAtMidnight
		const filterYear = filterLocalDateAtMidnight.getFullYear();
		const filterMonth = filterLocalDateAtMidnight.getMonth();
		const filterDate = filterLocalDateAtMidnight.getDate();

		// Compare based on local (SGT) year/month/day
		if (
			cellMoment.year() === filterYear &&
			cellMoment.month() === filterMonth &&
			cellMoment.date() === filterDate
		) {
			return 0;
		}

		const cellTime = cellMoment.toDate().getTime();
		const filterTime = new Date(filterYear, filterMonth, filterDate).getTime();

		return cellTime < filterTime ? -1 : 1;
	},
	browserDatePicker: true,
	suppressAndOrCondition: true,
	includeTime: false,
	defaultTime: '00:00:00',
};

export const dollarFilterParams = {
	comparator: (a, b) => {
		const valA = a == null ? 0 : parseFloat(a);
		const valB = b == null ? 0 : parseFloat(b);
		if (valA === valB) return 0;
		return valA > valB ? 1 : -1;
	},
	applyMiniFilterWhileTyping: true,
	valueFormatter: (p) => {
		return p.value != null ? `$ ${Math.floor(p.value)}` : '';
	},
};

export const dollarDecimalFilterParams = {
	comparator: (a, b) => {
		const valA = a == null ? 0 : parseFloat(a);
		const valB = b == null ? 0 : parseFloat(b);
		if (valA === valB) return 0;
		return valA > valB ? 1 : -1;
	},
	applyMiniFilterWhileTyping: true,
	valueFormatter: (p) => {
		return p.value != null ? `$ ${p.value}` : '';
	},
};

export const decimalFilterParams = {
	comparator: (a, b) => {
		const valA = a == null ? 0 : parseFloat(a);
		const valB = b == null ? 0 : parseFloat(b);
		if (valA === valB) return 0;
		return valA > valB ? 1 : -1;
	},
	applyMiniFilterWhileTyping: true,
	valueFormatter: (p) => {
		return p.value != null ? p.value?.toFixed(2) : '';
	},
};

export const decimalFilterParams1 = {
	comparator: (a, b) => {
		const valA = a == null ? 0 : parseFloat(a);
		const valB = b == null ? 0 : parseFloat(b);
		if (valA === valB) return 0;
		return valA > valB ? 1 : -1;
	},
	applyMiniFilterWhileTyping: true,
	valueFormatter: (p) => {
		return p.value != null ? p.value : '';
	},
};

export const numberFilterParams = {
	comparator: (a, b) => {
		var valA = a == null ? 0 : parseInt(a);
		var valB = b == null ? 0 : parseInt(b);
		if (valA === valB) return 0;
		return valA > valB ? 1 : -1;
	},
	applyMiniFilterWhileTyping: true,
};
